import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import { topic } from '@regent/realtime';
import { useChatUi } from '@/features/chat/api';
import { ChannelView } from '@/features/chat/channel-view';
import { useTopic, useViewing } from '@/lib/realtime';
import { useUi } from '@/stores/ui';

export const Route = createFileRoute('/w/$workspaceId/chat/$channelId')({
  // `?message=` jumps to a message; `?thread=` opens a thread in the side panel.
  validateSearch: (search: Record<string, unknown>): { message?: string; thread?: string } => ({
    ...(typeof search.message === 'string' ? { message: search.message } : {}),
    ...(typeof search.thread === 'string' ? { thread: search.thread } : {}),
  }),
  component: ChannelPage,
});

function ChannelPage() {
  const { workspaceId, channelId } = Route.useParams();
  const { message, thread } = Route.useSearch();
  const setActiveChannel = useChatUi((s) => s.setActiveChannel);
  const remember = useUi((s) => s.setActiveView);

  // Live messages and typing for this conversation, and presence for teammates.
  useTopic(topic.chat(channelId));
  useViewing(`chat:${channelId}`);
  useEffect(() => {
    setActiveChannel(channelId);
    remember(`chat:${workspaceId}`, channelId);
    return () => setActiveChannel(null);
  }, [channelId, workspaceId, setActiveChannel, remember]);

  return <ChannelView key={channelId} channelId={channelId} messageId={message} threadId={thread} />;
}
